// extracted by mini-css-extract-plugin
export var notificationHost = "_dr-0";